import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeTs } from 'locales';

interface Iprops {
  messages: HomeTs;
}


const Home = (props: Iprops) => {
  return (
    <>
      <NavLink to="/test">테스트</NavLink>
    </>
  )
}


export default Home



// WEBPACK FOOTER //
// ./src/pages/index.tsx